import { render, staticRenderFns } from "./ObjBox.vue?vue&type=template&id=1eee187e&"
import script from "./ObjBox.vue?vue&type=script&lang=js&"
export * from "./ObjBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports